import $api from "@/lib/queries/openapi";
import useGetTeamSettings from "@/lib/queries/useGetTeamSettings";
import useGetCurrentQuoteRevision from "@/lib/SelectedQuoteRevisionIdContext/useGetCurrentQuoteRevision";
import { useRef, useState } from "react";
import { useParams } from "react-router";

export default function Note() {
  const quoteRevision = useGetCurrentQuoteRevision();
  const canEditQuoteRevision = quoteRevision?.can_edit;
  const { teamSlug } = useParams();
  const teamSettings = useGetTeamSettings(teamSlug);
  const { mutate: saveNote } = $api.useMutation(
    "patch",
    "/api/teams/{team_slug}/quote_revisions/{id}",
  );
  const [input, setInput] = useState<string>();
  const initialValue =
    quoteRevision?.note ?? teamSettings?.["shop.default_quote_note"] ?? "";
  const timeoutRef = useRef<number>();

  return (
    <div className="p-4 flex flex-col gap-2">
      <div className="text-sm font-bold">Add Notes to Quote</div>
      <textarea
        disabled={!canEditQuoteRevision}
        placeholder="Add notes to quote"
        className="p-4 text-sm border rounded-sm"
        rows={10}
        value={input ?? initialValue}
        onChange={(e) => {
          const value = e.target.value;
          setInput(value);
          clearTimeout(timeoutRef.current);
          timeoutRef.current = setTimeout(
            () =>
              saveNote({
                params: {
                  path: { team_slug: teamSlug!, id: quoteRevision!.id },
                },
                body: { note: value },
              }),
            1000,
          );
        }}
      />
    </div>
  );
}
